
    <div class="tooltip-wrapper" [ngStyle]="style">
      <ng-content></ng-content>
    </div>